// Import Dependencies
import moment from 'moment';

const convertTimestampToDate = ((timestamp) => moment.unix(timestamp).toDate());

export default convertTimestampToDate;
